import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { CommunitiesWebsiteContext } from 'src/sites/custom/communities/components/context'

const PricingCard = ({ title, subtitle, price, features }) => {
   const { setContactModalOptions } = useContext(CommunitiesWebsiteContext)

   return (
      <div className="p-8 sm:pb-24 border-b-2 border-r-2 border-black border-solid transition-all">
         {title === 'Pro' && (
            <div className="h-12 w-full">
               <div className="text-xs py-1 inline bg-green-700/20 text-green-300 rounded-full px-3">
                  Most Popular
               </div>
            </div>
         )}
         {title !== 'Pro' && (
            <div className="hidden md:block h-12 w-full" />
         )}

         <div className="text-lg font-semibold text-white">{title}</div>
         <div className="text-base text-white/60 mb-2 sm:mb-6">{subtitle}</div>
         <div className="text-3xl font-medium text-white">{price}</div>
         <div className="text-xs text-white/60 mt-1">per month, billed annually</div>
         <button
            type="button"
            onClick={() => setContactModalOptions({ open: true, reason: title })}
            className="w-full font-semibold h-12 mt-8 rounded-md bg-white text-sm text-black hover:bg-green-300 transition-all cursor-pointer transform hover:translate-y-[-2px]">
            Get Started
         </button>
         <div className="space-y-2 sm:space-y-3 text-white/80 mt-8 border-t border-solid border-white/10 pt-8">
            {features.map(feature => (
               <div key={feature} className="flex items-center gap-4">
                  <div className="flex-0">✓</div>
                  <div className="flex-1">{feature}</div>
               </div>
            ))}
         </div>
      </div>
   )
}

PricingCard.propTypes = {
   title: PropTypes.string.isRequired,
   subtitle: PropTypes.string.isRequired,
   price: PropTypes.string.isRequired,
   // eslint-disable-next-line react/forbid-prop-types
   features: PropTypes.array.isRequired
}

export default PricingCard
